var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"paperdispatch"}},[_c('small',{staticClass:"color-gray"},[_vm._v("工作任务数据需要在考务系统PC端处理")])])}]

export { render, staticRenderFns }